// 発注
// タイプ
//
// ※ STATUS_HISTORY_TYPE_IDを追加する際の注意
// LOADING, COMPLETE, WITHDRAWのSTATUS_HISTORY_TYPE_ID は STATUS_HISTORY_TYPE_LABELとペアになって、
// components/layouts/HistoryList/Pages/Order/RowInfo.vue 内で使用されている。
// それ以外のSTATUS_HISTORY_TYPE_IDは個別に追加可能。
const STATUS_HISTORY_TYPE_ID = {
  LOADING: 1,
  COMPLETE: 2,
  WITHDRAW: 3,
  REGISTER: 4
}
// タイプ名
const STATUS_HISTORY_TYPE_LABEL = {
  LOADING: '入庫',
  COMPLETE: '完成',
  WITHDRAW: '出金'
}

// 出金状態
const WITHDRAW_STATUS = {
  ALL: 0,
  BEFORE_WITHDRAW: 1,
  AFTER_WITHDRAW: 4
}
// 入庫状態
const LOADING_STATUS = {
  ALL: 0,
  BEFORE_LOADING: 2,
  AFTER_LOADING: 5
}
// 注文状態
const COMPLETE_STATUS = {
  ALL: 0,
  BEFORE_COMPLETE: 3,
  AFTER_COMPLETE: 6,
  CANCEL: 99
}
// 入庫履歴検索の入庫状態
const REGISTER_STATUS = {
  ALL: 0,
  REGISTER: 1,
  CANCEL: 99
}

const STATUS_HISTORY_LABEL = {
  ALL: 'common.common_overall',
  BEFORE_WITHDRAW: 'payment.payment_not-payment-exe',
  BEFORE_LOADING: 'loading.loading_not-loading',
  BEFORE_COMPLETE: 'order.order_unfinished',
  AFTER_WITHDRAW: 'payment.payment_already-payment-exe',
  AFTER_LOADING: 'loading.loading_already-loading',
  AFTER_COMPLETE: 'sale.sale_completion',
  REGISTER: 'common.common_register',
  CANCEL: 'order.order_canceled-label',
  CANCEL_LITERAL: 'user.user_cancel'
}

export default {
  STATUS_HISTORY_LABEL,
  WITHDRAW_STATUS,
  LOADING_STATUS,
  COMPLETE_STATUS,
  REGISTER_STATUS,
  STATUS_HISTORY_TYPE_ID,
  STATUS_HISTORY_TYPE_LABEL
}
